var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67169 16.0021H8.3379C11.9546 16.0021 13.7632 16.0021 14.8864 14.8789C16.0096 13.7557 16 11.9477 16 8.34007V7.66423C16 4.05717 16 2.24854 14.8864 1.12534C13.7728 0.00213945 11.9546 0.00213623 8.3379 0.00213623H7.67169C4.05441 0.00213623 2.2464 0.00213945 1.1232 1.12534C-7.15256e-07 2.24854 0 4.05589 0 7.66423V8.34007C0 11.9477 -7.15256e-07 13.7557 1.1232 14.8789C2.2464 16.0021 4.05441 16.0021 7.67169 16.0021Z",
    fill: "#2D67D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58633 11.5385C4.97865 11.5385 2.78922 9.03547 2.7041 4.8761H4.5313C4.58827 7.93147 5.97833 9.2281 7.04396 9.49241V4.8761H8.79561V7.51225C9.82346 7.39835 10.8987 6.19897 11.2609 4.8761H12.9831C12.7073 6.50363 11.5367 7.70297 10.7086 8.19769C11.5367 8.59769 12.8692 9.64472 13.3831 11.5385H11.4894C11.0894 10.2726 10.1089 9.2921 8.79561 9.15897V11.5385H8.58633Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.0292ed6f0ffdf55a75927dc0bd6c2c0c.svg";
export { ForwardRef as ReactComponent };